































import { defineComponent } from '@vue/composition-api';

const NotFound = defineComponent({
  props: {
    full: {
      default() { return false; },
    },
  },
  // setup() {},
});

export default NotFound;
